import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

export const CommonTnc = (): JSX.Element => {
  const { i18n } = useTranslation();
  const termsNConditionshref =
    i18n.language == 'en'
      ? 'https://www.generali.com.hk/EN_US/legal_information'
      : 'https://www.generali.com.hk/ZH_HK/legal_information';
  const privacyPolicyhref =
    i18n.language == 'en'
      ? 'https://www.generali.com.hk/EN_US/privacy_security_cookies'
      : 'https://www.generali.com.hk/ZH_HK/privacy_security_cookies';
  const personalInfoCollectionDochref =
    i18n.language == 'en'
      ? 'https://www.generali.com.hk/EN_US/personal_information'
      : 'https://www.generali.com.hk/ZH_HK/personal_information';
  return (
    <Trans i18nKey="common.termNPolicyLi" style={{ marginLeft: '20px', fontSize: '17px' }}>
      {[
        <a
          key="termsNConditions"
          href={termsNConditionshref}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        />,
        <a
          key="privacyPolicy"
          href={privacyPolicyhref}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        />,
        <a
          key="personalInfoCollectionDoc"
          href={personalInfoCollectionDochref}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        />,
      ]}
    </Trans>
  );
};
